import { ReturnStatus } from "@redotech/redo-return-core-common/return-status";
import { ReturnStatusZod } from "@redotech/redo-return-core-common/return-status-zod";
import * as z from "zod";

/**
 * Keep in sync with the generated `ProcessingAutomationRaw` in
 * redo/backend/db/schema/src/types/Team.schema.d.ts.
 */
export interface ProcessingAutomation {
  exchanges: ReturnStatus;
  refunds: ReturnStatus;
  store_credit: ReturnStatus;
  exchanges_delay: number;
  refunds_delay: number;
  store_credit_delay: number;
}

const ProcessingAutomationZodSchema_ = z.object({
  exchanges: ReturnStatusZod,
  refunds: ReturnStatusZod,
  store_credit: ReturnStatusZod,
  exchanges_delay: z.number(),
  refunds_delay: z.number(),
  store_credit_delay: z.number(),
});
export const ProcessingAutomationZodSchema: z.ZodType<ProcessingAutomation> =
  ProcessingAutomationZodSchema_;
